export function requiresRegistrationPayment(
  subscriptionPrice: number | null | undefined,
  productsPrice: number | null | undefined,
  shippingPrice: number | null | undefined,
): boolean {
  // These are pre-coupon prices; discounts never make card details optional.
  return subscriptionPrice !== 0 || productsPrice !== 0 || shippingPrice !== 0;
}
